var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 4H5.33317C3.86041 4 2.6665 5.19391 2.6665 6.66667V7.33333M3.99984 12.6667H10.6665C12.1393 12.6667 13.3332 11.4728 13.3332 10V9.33333M11.3332 6L12.8618 4.4714C13.1221 4.21106 13.1221 3.78895 12.8618 3.5286L11.3332 2M4.6665 10.6667L3.13791 12.1953C2.87756 12.4556 2.87756 12.8777 3.13791 13.1381L4.6665 14.6667",
    stroke: "#000536",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.06d72479577508c3f8ae49375695314e.svg";
export { ForwardRef as ReactComponent };